import React from 'react';
import { Box } from '@mui/material';
import { styled } from 'theme';
import { useTheme } from '@mui/material/styles';
import { InstructionsMessage } from '../InstructionsMessage/InstructionsMessage';
import { useAppSelector } from 'hooks/useAppSelector';
import { getHelpSpotlightCss } from 'utils/getHelpSpotlightCss';

const Overlay = styled(Box)(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.75)',
    mixBlendMode: 'hard-light',
    zIndex: theme.zIndex.appBar + 304,
}));

const SquareHole = styled(Box)({
    position: 'absolute',
    borderRadius: '12px',
    backgroundColor: 'gray',
});

const RoundHole = styled(Box)({
    position: 'absolute',
    borderRadius: '50%',
    backgroundColor: 'gray',
});

export const HelpOverlay: React.FC = () => {
    const theme = useTheme();
    const { showHelp, helpOption, currentMessageIndex } = useAppSelector((s) => s.help);
    const isLoggedIn = useAppSelector((s) => s.auth.userLoginSuccess && !!s.auth.jwt);

    const [shape, setShape] = React.useState<'circle' | 'square'>('circle');
    const onClickHoleRef = React.useRef<() => void>(() => undefined);

    if (!showHelp) return null;

    return (
        <>
            <Overlay
                onClick={() => {
                    onClickHoleRef.current?.();
                }}
            >
                {shape === 'square' ? (
                    <SquareHole
                        sx={getHelpSpotlightCss(helpOption, currentMessageIndex, isLoggedIn)}
                    />
                ) : (
                    <RoundHole
                        sx={getHelpSpotlightCss(helpOption, currentMessageIndex, isLoggedIn)}
                    />
                )}
            </Overlay>

            <Box sx={{ position: 'relative', zIndex: theme.zIndex.appBar + 305 }}>
                <InstructionsMessage onShapeChange={setShape} onClickHoleRef={onClickHoleRef} />
            </Box>
        </>
    );
};

